export const SET_COUNTER_SUCCESS = 'SET_COUNTER_SUCCESS'
export const SET_COUNTER_LOADING = 'SET_COUNTER_LOADING'
export const SET_COUNTER_FAIL = 'SET_COUNTER_FAIL'

export const CHANGE_PAGE_SUCCESS = 'CHANGE_PAGE_SUCCESS'
export const CHANGE_PAGE_LOADING = 'CHANGE_PAGE_LOADING'
export const CHANGE_PAGE_FAIL = 'CHANGE_PAGE_FAIL'
